import { render, staticRenderFns } from "./PackagesStarter.vue?vue&type=template&id=1372c1c1&"
import script from "./PackagesStarter.vue?vue&type=script&lang=js&"
export * from "./PackagesStarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports